import { render } from "./VideosUploader.vue?vue&type=template&id=a62feb82&scoped=true"
import script from "./VideosUploader.vue?vue&type=script&lang=js"
export * from "./VideosUploader.vue?vue&type=script&lang=js"

import "./VideosUploader.vue?vue&type=style&index=0&id=a62feb82&lang=scss"
import "./VideosUploader.vue?vue&type=style&index=1&id=a62feb82&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a62feb82"]])

export default __exports__